import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import MainLayout from "../../../components/layout/MainLayout";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import TreatmentPlanForm from "./TreatmentPlanForm";
import { createTreatmentPlan } from "../../../store/slices/treatmentPlanSlice";

const AddTreatmentPlan = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const dispatch = useDispatch();

    const [formData, setFormData] = useState({
        caseId: state?.caseId || null,
        patientId: state?.patientId || null,
        treatmentOption: "",
        reason: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Map formData to snake_case keys for backend
        const payload = {
            patient_id: formData.patientId,
            case_id: formData.caseId,
            treatment_option: formData.treatmentOption,
            reason: formData.reason,
        };

        try {
            await dispatch(createTreatmentPlan(payload)).unwrap();

            Swal.fire({
                title: "Saved!",
                text: "Treatment Plan Form completed.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false
            });

            navigate("/home-visit/treatment-plan"); // Adjust path as needed
        } catch (err) {
            Swal.fire("Error!", err || "Failed to save Treatment Plan.", "error");
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <TreatmentPlanForm formData={formData} handleChange={handleChange} />
                            <div className="col-12 d-flex justify-content-end mt-3">
                                <div className="col-md-2 d-flex justify-content-end">
                                    <button
                                        type="submit"
                                        className="btn btn-primary px-4 sticky-form-submit"
                                    >
                                        <i className="ri-save-2-line me-1"></i>
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddTreatmentPlan;
